<template>
    <div style="z-index: 1000">
        <label :class="['label', { 'label--required': required }]" :for="name">
            <slot></slot>
        </label>
        <v-date-picker
            v-model="selectedDate"
            :model-config="modelConfig"
            :color="color"
            :min-date="minDate"
            :max-date="maxDate"
            :is-dark="dark"
            :is-required="required"
            :popover="popoverObject"
            @input="inputValue => $emit('input', inputValue)"
        >
            <template v-slot="{ inputValue, inputEvents }">
                <input
                    :id="'v_date_' + name"
                    :name="name"
                    class="input"
                    :value="inputValue"
                    v-on="inputEvents"
                    :disabled="disabled"
                />
            </template>
        </v-date-picker>
        <span class="invalid-feedback" v-if="computedError">
            <strong>{{ computedError }}</strong>
        </span>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'input',
    },

    props: {
        name,
        error: {
            default: null,
        },
        value: {
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        minDate: {
            default: null,
        },
        maxDate: {
            default: null,
        },
        dark: {
            type: Boolean,
            default: false,
        },
        initialDate: {
            default: null,
        },
        disabled: {
            default: false,
        },
    },

    data() {
        return {
            selectedDate: this.value || this.initialDate,
            modelConfig: {
                type: 'string',
                mask: 'YYYY-MM-DD',
            },
            color: 'gray',
            popoverObject: {
                visibility: this.disabled ? 'hidden' : 'hover-focus',
            },
        };
    },

    computed: {
        computedError() {
            return this.error || this.errors(this.name);
        },
    },

    mounted() {
        // Shout the preselected date to parent component.
        if (this.selectedDate) {
            this.selectedDate = new Date(this.selectedDate)
                .toISOString()
                .substr(0, 10);
        }
        this.$emit('input', this.selectedDate);
    },
};
</script>
